import { logger } from '@nykaa/nes-logger';
import axios, {
  Method,
  AxiosError,
  AxiosResponse,
  AxiosRequestConfig,
} from 'axios';

import { defaultRequestOptions } from './constants';
import { AdditionalRequestOptions, InterceptorFunction } from './types';

export class RequestConfig {
  private static formKey: string;
  private static storeId: string;

  public static setFormKey(formKey: string) {
    RequestConfig.formKey = formKey;
  }

  public static getFormKey() {
    return RequestConfig.formKey;
  }

  public static setStoreId(storeId: string) {
    RequestConfig.storeId = storeId;
  }

  public static getStoreId() {
    return RequestConfig.storeId;
  }
}

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (typeof window === 'undefined') {
      // Server-side logic
      console.log(`[SERVER] Request to: ${config.url} with config:`, config);
      logger.info(config, `[SERVER] Request to: ${config.url} with config:`);
    }
    return config;
  },
  (error: AxiosError) => {
    if (typeof window === 'undefined') {
      // Server-side logic
      console.log(
        `[SERVER] Request Error to: ${error.config?.url}, with error:`,
        error
      );
      logger.error(
        error,
        `[SERVER] Request Error to: ${error.config?.url}, with error:`
      );
    }
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    if (typeof window === 'undefined') {
      // Server-side logic
      console.log(
        `[SERVER] Response from: ${response.config.url} with response:`,
        response
      );
      logger.info(
        response,
        `[SERVER] Response from: ${response.config.url} with response:`
      );
    }
    return response;
  },
  (error: AxiosError) => {
    if (typeof window === 'undefined') {
      // Server-side logic
      console.log(
        `[SERVER] Response Error from:${error.config?.url} with error:`,
        error
      );
      logger.error(
        error,
        `[SERVER] Response Error from:${error.config?.url} with error:`
      );
    }
    return Promise.reject(error);
  }
);

// FIXME: rename me ASAP!!
export const ApiHelper = (
  url: string,
  method: Method = 'get',
  params?: { [key: string]: any } | FormData,
  headers?: { [key: string]: string },
  additionalOptions: AdditionalRequestOptions = defaultRequestOptions,
  timeout: number = 20000
) => {
  if (!url) {
    throw new Error('"url" cannot be empty!');
  }
  const customRequestHeaders = {
    ...(headers && { ...headers }),
    ...{
      ...defaultRequestOptions,
      ...additionalOptions,
    },
  };
  const axiosParams = {
    url,
    method,
    timeout,
    headers: customRequestHeaders,
    ...(params && { data: params }),
  };

  return axios(axiosParams);
};

export const addRequestInterceptor = (
  interceptorFunction: InterceptorFunction
) => {
  try {
    axios.interceptors.request.use(interceptorFunction);
  } catch (e) {
    logger.error(e, 'Error adding request Interceptor');
  }
};
